<template>
    <div class="container my-5">
        <div class="row justify-content-between my-2">
            <div v-if="lastUpdate" class="col-12 mb-2">
                <small class="text-secondary">
                    {{ localise("global", "lastUpdate") }}:
                    {{ moment(lastUpdate).format("YYYY-MM-D H:mm:ss") }}
                </small>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 my-1">
                <div class="d-flex align-items-center">
                    <select
                        id="perPage"
                        class="form-select py-2 rounded-c-3 sm-select"
                        v-model="params.perPage"
                    >
                        <option
                            class="bg-dark text-white"
                            v-for="(length, index) in params.pageLength"
                            :key="index"
                            :value="length.value"
                        >
                            {{ length.value }}
                        </option>
                    </select>
                    <label for="perPage" class="form-label ms-1 mt-1"
                        ><small>
                            {{ localise("datatables", "per_page") }}
                        </small></label
                    >
                </div>
            </div>
            <div class="col-sm-6 col-md-5 col-lg-3 my-1">
                <input
                    class="form-control py-2 rounded-c-3"
                    type="text"
                    @input="debounceSearch"
                    :placeholder="localise('datatables', 'search')"
                />
            </div>
        </div>
        <button
            class="btn btn-c-secondary rounded-c-3 px-4 py-2 text-white shadow mb-2 me-1"
            @click="showFilters"
        >
            <i class="fas fa-filter fa-sm"></i>
            {{ localise("datatables", "filters") }}
        </button>
        <button
            type="button"
            class="btn btn-c-secondary rounded-c-3 px-4 py-2 text-white shadow mb-2"
            data-bs-toggle="modal"
            data-bs-target="#sendModal"
        >
            <i class="fas fa-envelope fa-sm"></i>
            {{ localise("contact", "send") }}
        </button>
        <div
            v-show="filters"
            class="row justify-content-center mb-2 py-4 mx-1 w-100 bg-light rounded-c-3"
        >
            <div class="col-sm-6 col-md-4 my-1" v-if="name !== 'agencies'">
                <v-select
                    multiple
                    v-model="params.category_id"
                    :options="categories"
                    :reduce="(category) => category.id"
                    :label="`name_${$store.state.locale}`"
                    :placeholder="localise('datatables', 'all_categories')"
                />
            </div>
            <div class="col-sm-6 col-md-4 my-1" v-if="name !== 'guides'">
                <v-select
                    multiple
                    v-model="params.municipality_id"
                    :options="municipalities"
                    :reduce="(municipality) => municipality.id"
                    :label="`name_${$store.state.locale}`"
                    :placeholder="localise('datatables', 'all_municipalities')"
                />
            </div>
            <div class="col-sm-6 col-md-4 my-1" v-if="name === 'agencies'">
                <v-select
                    multiple
                    v-model="params.serviceIds"
                    :options="services"
                    :reduce="(service) => service.id"
                    :label="`name_${$store.state.locale}`"
                    :placeholder="localise('datatables', 'all_services')"
                />
            </div>
            <div
                v-if="
                    name !== 'transports' &&
                    name !== 'agencies' &&
                    name !== 'guides'
                "
                class="col-sm-6 col-md-4 my-1"
            >
                <v-select
                    v-model="params.village_id"
                    :options="villages"
                    :reduce="(village) => village.id"
                    :label="`name_${$store.state.locale}`"
                    :placeholder="localise('datatables', 'all_villages')"
                />
            </div>
            <div class="col-sm-6 col-md-4 my-1" v-if="name === 'transports'">
                <input
                    type="number"
                    min="1900"
                    class="form-control bg-light rounded-1 py-1 border-input"
                    v-model="params.car_release_year"
                    :placeholder="localise('datatables', 'car_release_year')"
                />
            </div>
            <div class="col-sm-6 col-md-4 my-1" v-if="name === 'transports'">
                <v-select
                    v-model="params.seats"
                    :options="car_seats"
                    :placeholder="localise('datatables', 'seats')"
                />
            </div>
        </div>
        <div class="d-flex flex-wrap gap-1 mt-1 mb-2">
            <button
                v-if="!selected.length"
                class="btn btn-c-primary rounded-c-3 px-4 py-3 text-white shadow dropdown-toggle"
                type="button"
                id="allExportDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                <i class="fas fa-download fa-sm"></i>
                {{ localise("datatables", "download_all") }}
            </button>
            <ul
                class="dropdown-menu dropdown-menu-dark rounded-c-3 border-0 shadow"
                aria-labelledby="allExportDropdown"
            >
                <li>
                    <h6 class="dropdown-header">
                        {{ localise("datatables", "choose_language") }}
                    </h6>
                </li>
                <li>
                    <a
                        class="dropdown-item"
                        href="#!"
                        @click.prevent="exportRecords('ka')"
                        >{{ localise("datatables", "georgian") }}</a
                    >
                </li>
                <li>
                    <a
                        class="dropdown-item"
                        href="#!"
                        @click.prevent="exportRecords('en')"
                        >{{ localise("datatables", "english") }}</a
                    >
                </li>
                <li>
                    <a
                        class="dropdown-item"
                        href="#!"
                        @click.prevent="exportRecords('ru')"
                        >{{ localise("datatables", "russian") }}</a
                    >
                </li>
            </ul>
            <button
                class="btn btn-c-primary rounded-c-3 px-4 py-3 text-white shadow dropdown-toggle"
                type="button"
                id="exportDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                v-show="selected.length"
            >
                <i class="fas fa-download fa-sm"></i>
                {{ localise("datatables", "download") }}
                {{ selected.length }}
                <span v-if="selected.length > 1">{{
                    localise("datatables", "records")
                }}</span>
                <span v-else>{{ localise("datatables", "record") }}</span>
            </button>
            <ul
                class="dropdown-menu dropdown-menu-dark rounded-c-3 border-0 shadow"
                aria-labelledby="exportDropdown"
            >
                <li>
                    <h6 class="dropdown-header">
                        {{ localise("datatables", "choose_language") }}
                    </h6>
                </li>
                <li>
                    <a
                        class="dropdown-item"
                        href="#!"
                        @click.prevent="exportRecords('ka')"
                        >{{ localise("datatables", "georgian") }}</a
                    >
                </li>
                <li>
                    <a
                        class="dropdown-item"
                        href="#!"
                        @click.prevent="exportRecords('en')"
                        >{{ localise("datatables", "english") }}</a
                    >
                </li>
                <li>
                    <a
                        class="dropdown-item"
                        href="#!"
                        @click.prevent="exportRecords('ru')"
                        >{{ localise("datatables", "russian") }}</a
                    >
                </li>
            </ul>
            <button
                v-if="
                    name === 'hotels' ||
                    name === 'restaurants' ||
                    name === 'entertainments' ||
                    name === 'agencies' ||
                    name === 'transports' ||
                    name === 'guides'
                "
                @click="isOpened = true"
                class="btn btn-c-primary rounded-c-3 px-4 py-3 text-white shadow"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#addNewRecordModal"
            >
                <i class="fas fa-plus-circle fa-sm"></i>
                {{ localise("new_record", "registration") }}
            </button>
        </div>
        <div class="table-responsive">
            <table class="table table-striped">
                <thead class="bg-c-secondary text-white">
                    <tr>
                        <th scope="col" class="text-center w-10"></th>
                        <th
                            scope="col"
                            class="cursor-pointer"
                            @click.prevent="
                                changeSort(`name_${$store.state.locale}`)
                            "
                        >
                            <small v-if="name !== 'guides'">{{
                                localise("datatables", "name")
                            }}</small>
                            <small v-else>{{
                                localise("tour_form", "name")
                            }}</small>
                            <span
                                v-if="
                                    params.sortBy ==
                                        `name_${$store.state.locale}` &&
                                    params.sortDirection == 'asc'
                                "
                                ><i class="fas fa-caret-up fa-xs"></i
                            ></span>
                            <span
                                v-if="
                                    params.sortBy ==
                                        `name_${$store.state.locale}` &&
                                    params.sortDirection == 'desc'
                                "
                                ><i class="fas fa-caret-down fa-xs"></i
                            ></span>
                        </th>
                        <th
                            scope="col"
                            class="cursor-pointer"
                            @click.prevent="changeSort('category_id')"
                            v-if="name !== 'agencies' && name !== 'guides'"
                        >
                            <small>{{
                                localise("datatables", "category")
                            }}</small>
                            <span
                                v-if="
                                    params.sortBy == 'category_id' &&
                                    params.sortDirection == 'asc'
                                "
                                ><i class="fas fa-caret-up fa-xs"></i
                            ></span>
                            <span
                                v-if="
                                    params.sortBy == 'category_id' &&
                                    params.sortDirection == 'desc'
                                "
                                ><i class="fas fa-caret-down fa-xs"></i
                            ></span>
                        </th>
                        <th scope="col" v-if="name === 'guides'">
                            <small>{{
                                localise("datatables", "category")
                            }}</small>
                        </th>
                        <th
                            scope="col"
                            class="cursor-pointer"
                            @click.prevent="changeSort('municipality_id')"
                            v-if="name !== 'guides'"
                        >
                            <small>{{
                                localise("datatables", "municipality")
                            }}</small>
                            <span
                                v-if="
                                    params.sortBy == 'municipality_id' &&
                                    params.sortDirection == 'asc'
                                "
                                ><i class="fas fa-caret-up fa-xs"></i
                            ></span>
                            <span
                                v-if="
                                    params.sortBy == 'municipality_id' &&
                                    params.sortDirection == 'desc'
                                "
                                ><i class="fas fa-caret-down fa-xs"></i
                            ></span>
                        </th>
                        <th
                            v-if="
                                name !== 'transports' &&
                                name !== 'agencies' &&
                                name !== 'guides'
                            "
                            scope="col"
                        >
                            <small>{{
                                localise("datatables", "village")
                            }}</small>
                        </th>
                        <th scope="col">
                            <small>{{ localise("datatables", "phone") }}</small>
                        </th>
                        <th v-if="name === 'hotels'" scope="col">
                            <small>{{ localise("datatables", "rooms") }}</small>
                        </th>
                        <th v-if="name === 'hotels'" scope="col">
                            <small>{{ localise("datatables", "beds") }}</small>
                        </th>
                        <th scope="col" v-if="name !== 'guides'">
                            <small>{{
                                localise("datatables", "address")
                            }}</small>
                        </th>
                        <th scope="col">
                            <small v-if="name !== 'guides'">
                                {{
                                    localise("datatables", "website_email")
                                }}</small
                            >
                            <small v-else>{{
                                localise("datatables", "email")
                            }}</small>
                        </th>
                        <th v-if="name === 'restaurants'" scope="col">
                            <small>{{
                                localise("datatables", "cuisine")
                            }}</small>
                        </th>
                        <th scope="col" v-if="name === 'guides'">
                            <small>{{
                                localise("datatables", "association")
                            }}</small>
                        </th>
                        <th scope="col" v-if="name === 'guides'">
                            <small>{{
                                localise("datatables", "working")
                            }}</small>
                        </th>
                        <th scope="col" v-if="name === 'agencies'">
                            <small>{{
                                localise("new_record", "services")
                            }}</small>
                        </th>
                        <th scope="col" v-if="name === 'transports'">
                            <small>{{
                                localise("datatables", "car_release_year")
                            }}</small>
                        </th>
                        <th scope="col" v-if="name === 'transports'">
                            <small>{{ localise("datatables", "seats") }}</small>
                        </th>
                    </tr>
                </thead>
                <tbody class="border-top-0">
                    <tr v-for="(record, index) in records" :key="index">
                        <th scope="row" class="text-center">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :value="record.id"
                                v-model="selected"
                            />
                        </th>
                        <td>
                            <small>{{
                                record[`name_${$store.state.locale}`]
                            }}</small>
                        </td>
                        <td v-if="name !== 'agencies' && name !== 'guides'">
                            <small>{{
                                record.category[`name_${$store.state.locale}`]
                            }}</small>
                        </td>
                        <td class="text-wrap" v-if="name === 'guides'">
                            <small
                                v-for="(category, index) in record.categories"
                                :key="category.id"
                            >
                                {{ category[`name_${$store.state.locale}`]
                                }}<small
                                    v-if="
                                        record.categories.length !== index + 1
                                    "
                                    >,
                                </small>
                            </small>
                        </td>
                        <td v-if="name !== 'guides'">
                            <small>{{
                                record.municipality[
                                    `name_${$store.state.locale}`
                                ]
                            }}</small>
                        </td>
                        <td
                            v-if="
                                name !== 'transports' &&
                                name !== 'agencies' &&
                                name !== 'guides'
                            "
                        >
                            <small>{{
                                record.village_id
                                    ? record.village[
                                          `name_${$store.state.locale}`
                                      ]
                                    : "-"
                            }}</small>
                        </td>
                        <td class="text-wrap">
                            <small>{{ record.mobile ?? "-" }}</small>
                        </td>
                        <td v-if="name === 'hotels'">
                            <small>{{ record.rooms ?? "-" }}</small>
                        </td>
                        <td v-if="name === 'hotels'">
                            <small>{{ record.beds ?? "-" }}</small>
                        </td>
                        <td class="text-wrap" v-if="name !== 'guides'">
                            <small v-if="record.street"
                                >{{
                                    record.street[
                                        `name_${$store.state.locale}`
                                    ]
                                }}, {{ record.address_number }}</small
                            >
                            <small v-else>-</small>
                        </td>
                        <td class="text-wrap">
                            <p class="m-0" v-if="name !== 'guides'">
                                <small>{{ record.website }}</small>
                            </p>
                            <p class="m-0">
                                <small>{{ record.email }}</small>
                            </p>
                        </td>
                        <td class="text-wrap" v-if="name === 'restaurants'">
                            <small
                                class="m-0"
                                v-for="(cuisine, index) in record.cuisines"
                                :key="cuisine.id"
                            >
                                <span>{{
                                    cuisine[`name_${$store.state.locale}`] ??
                                    "-"
                                }}</span
                                ><span
                                    v-if="record.cuisines.length !== index + 1"
                                    >,
                                </span>
                            </small>
                        </td>
                        <td class="text-wrap" v-if="name === 'guides'">
                            <p
                                class="m-0"
                                v-for="association in record.associations"
                                :key="association.id"
                            >
                                <small>{{
                                    association[
                                        `name_${$store.state.locale}`
                                    ] ?? "-"
                                }}</small>
                            </p>
                        </td>
                        <td class="text-wrap" v-if="name === 'guides'">
                            <small v-if="record.working_from">
                                <span v-if="$store.state.locale === 'ka'">{{
                                    `${record.working_from} წლიდან` ?? "-"
                                }}</span>
                                <span
                                    v-else-if="$store.state.locale === 'en'"
                                    >{{
                                        `From ${record.working_from} year` ??
                                        "-"
                                    }}</span
                                >
                                <span
                                    v-else-if="$store.state.locale === 'ru'"
                                    >{{
                                        `С ${record.working_from} года` ?? "-"
                                    }}</span
                                >
                            </small>
                            <small v-else>-</small>
                        </td>
                        <td class="text-wrap" v-if="name === 'agencies'">
                            <img
                                v-for="service in record.services"
                                :key="service.id"
                                :src="`https://intranet.infoajara.com/storage/${service.image}`"
                                :alt="
                                    service[`name_${$store.state.locale}`] ??
                                    '-'
                                "
                                :title="
                                    service[`name_${$store.state.locale}`] ??
                                    '-'
                                "
                                height="20"
                                class="ms-1"
                            />
                        </td>
                        <td v-if="name === 'transports'">
                            <small>{{ record.car_release_year ?? "-" }}</small>
                        </td>
                        <td v-if="name === 'transports'">
                            <small>{{ record.seats ?? "-" }}</small>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div
            class="d-flex align-items-center justify-content-between flex-direction"
        >
            <div class="my-1">
                <small>
                    {{ localise("datatables", "showing") }}
                    {{ pagination.from }}
                    {{ localise("datatables", "from") }}
                    {{ pagination.to }}
                    {{ localise("datatables", "to") }}
                    {{ pagination.total }}
                    {{ localise("datatables", "from_records") }}
                </small>
            </div>
            <nav class="my-1">
                <ul class="pagination flex-wrap">
                    <li
                        v-for="(link, index) in pagination.links"
                        :key="index"
                        class="page-item"
                        :class="link.active === true ? 'active' : ''"
                    >
                        <a
                            class="page-link"
                            href="#table"
                            @click="changePage(link.label)"
                            v-if="link.label.length <= 3"
                            >{{ link.label }}</a
                        >
                    </li>
                </ul>
            </nav>
        </div>
    </div>
    <!-- Send Modal -->
    <div
        class="modal fade"
        id="sendModal"
        tabindex="-1"
        aria-labelledby="sendModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content rounded-c-3">
                <div class="modal-header">
                    <h6 class="modal-title" id="sendModalLabel"></h6>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <form @submit.prevent="sendRecords" class="modal-body">
                    <div class="form-group d-flex align-items-center gap-1">
                        <input
                            type="email"
                            class="form-control py-3 rounded-c-3"
                            :placeholder="localise('contact', 'email')"
                            v-model="email"
                            required
                        />
                        <button
                            class="btn btn-c-primary rounded-c-3 px-4 py-3 text-white shadow"
                            type="submit"
                        >
                            {{ localise("contact", "send") }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <AddNewRecord
        :type="name"
        :isOpened="isOpened"
        :categories="categories"
        :municipalities="municipalities"
        :villages="villages"
        @changeIsOpened="(event) => (isOpened = event)"
    />
    <LoadingOverlay :loading="$store.state.loading" />
</template>

<script>
import translations from "../../helpers/translations";
import LoadingOverlay from "../others/LoadingOverlay.vue";
import {
    getData,
    getCategoriesData,
    getMunicipalitiesData,
    getVillagesData,
    exportData,
    sendToEmail,
    getLastUpdate,
    getServicesData,
} from "../../services/ExternalApiService";
import moment from "moment";
import AddNewRecord from "./AddNewRecord.vue";
import { car_seats } from "../../helpers/seats";

export default {
    components: { LoadingOverlay, AddNewRecord },
    name: "InformationBase",
    props: ["name"],
    data() {
        return {
            records: [],
            categories: [],
            municipalities: [],
            villages: [],
            services: [],
            selected: [],
            filters: false,
            moment,
            lastUpdate: "",
            params: {
                page: 1,
                pageLength: [
                    { value: 10 },
                    { value: 25 },
                    { value: 50 },
                    { value: 75 },
                    { value: 100 },
                ],
                perPage: 10,
                search: "",
                sortBy: this.name === "guides" ? "experience" : "id",
                sortDirection: this.name === "guides" ? "desc" : "asc",
                category_id: [],
                municipality_id: [],
                village_id: "",
                serviceIds: [],
                car_release_year: null,
                seats: null,
            },
            pagination: {},
            email: "",
            debounce: null,
            isOpened: false,
            car_seats,
        };
    },
    watch: {
        name: {
            handler() {
                this.reset();
                this.getCategories();
                this.getResults();
            },
            deep: true,
        },
        params: {
            handler() {
                this.getResults();
                this.updateQueryParams();
            },
            deep: true,
        },
    },
    methods: {
        getResults() {
            this.$store.state.loading = true;
            setTimeout(() => {
                getData(this.name, {
                    page: (this.params.page =
                        this.$route.query.page ?? this.params.page),
                    perPage: (this.params.perPage =
                        this.$route.query.perPage ?? this.params.perPage),
                    search: (this.params.search =
                        this.$route.query.search ?? this.params.search),
                    sortBy: (this.params.sortBy =
                        this.$route.query.sortBy ?? this.params.sortBy),
                    sortDirection: (this.params.sortDirection =
                        this.$route.query.sortDirection ??
                        this.params.sortDirection),
                    category_id: this.params.category_id,
                    municipality_id: this.params.municipality_id,
                    village_id: (this.params.village_id =
                        this.$route.query.village_id ?? this.params.village_id),
                    serviceIds: this.params.serviceIds,
                    car_release_year: (this.params.car_release_year =
                        this.$route.query.car_release_year ??
                        this.params.car_release_year),
                    seats: (this.params.seats =
                        this.$route.query.seats ?? this.params.seats),
                })
                    .then((res) => {
                        this.$store.state.loading = false;
                        this.records = res.data.data;
                        this.pagination = {
                            current_page: res.data.current_page,
                            first_page_url: res.data.first_page_url,
                            from: res.data.from,
                            last_page: res.data.last_page,
                            last_page_url: res.data.last_page_url,
                            links: res.data.links,
                            next_page_url: res.data.next_page_url,
                            prev_page_url: res.data.prev_page_url,
                            to: res.data.to,
                            total: res.data.total,
                        };
                    })
                    .catch(console.error());
            }, 0);
        },
        getCategories() {
            getCategoriesData(this.name)
                .then((res) => {
                    this.categories = res.data;
                })
                .catch(console.error());
        },
        getMunicipalities() {
            getMunicipalitiesData()
                .then((res) => {
                    this.municipalities = res.data.municipalities;
                })
                .catch(console.error());
        },
        getVillages() {
            getVillagesData()
                .then((res) => {
                    this.villages = res.data.villages;
                })
                .catch(console.error());
        },
        getServices() {
            getServicesData(this.name)
                .then((res) => {
                    this.services = res.data;
                })
                .catch(console.error());
        },
        exportRecords(lang) {
            this.$store.state.loading = true;
            exportData(
                this.name,
                {
                    lang: lang,
                    category_id: this.params.category_id,
                    municipality_id: this.params.municipality_id,
                    village_id: this.params.village_id,
                    selected: this.selected,
                    serviceIds: this.params.serviceIds,
                    car_release_year: this.params.car_release_year,
                    seats: this.params.seats,
                },
                "blob"
            )
                .then((response) => {
                    this.$store.state.loading = false;
                    const blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
                .catch(console.error);
            this.selected = [];
        },
        sendRecords() {
            this.$store.state.loading = true;
            sendToEmail(this.name, {
                lang: this.$store.state.locale,
                category_id: this.params.category_id,
                municipality_id: this.params.municipality_id,
                village_id: this.params.village_id,
                selected: this.selected,
                email: this.email,
                serviceIds: this.params.serviceIds,
                car_release_year: this.params.car_release_year,
                seats: this.params.seats,
            })
                .then((res) => {
                    this.$store.state.loading = false;
                    if (res.status === 200) {
                        this.closeModal();
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    } else {
                        Swal.fire({
                            position: "center",
                            icon: "warning",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }
                })
                .catch(console.error());
            this.selected = [];
            this.email = "";
        },
        getLastUpdateDate() {
            getLastUpdate({ category: this.name })
                .then((res) => (this.lastUpdate = res.data))
                .catch((err) => console.log(err));
        },
        changeSort(column) {
            if (this.params.sortBy === column) {
                this.params.sortDirection =
                    this.params.sortDirection === "asc" ? "desc" : "asc";
            } else {
                this.params.sortBy = column;
                this.params.sortDirection = "asc";
            }
        },
        changePage(page) {
            this.params.page = page;
        },
        showFilters() {
            this.filters = !this.filters;
        },
        closeModal() {
            let bookingModal = document.querySelector(".modal.show");
            let modal = bootstrap.Modal.getInstance(bookingModal);
            modal.hide();
        },
        reset() {
            this.selected = [];
            this.filters = false;
            this.params.page = 1;
            this.params.perPage = 10;
            this.params.search = "";
            this.params.sortBy = this.name === "guides" ? "experience" : "id";
            this.params.sortDirection = this.name === "guides" ? "desc" : "asc";
            this.params.category_id = [];
            this.params.municipality_id = [];
            this.params.village_id = "";
            this.email = "";
            this.params.serviceIds = [];
            this.params.car_release_year = null;
            this.params.seats = null;
        },
        localise(cat, key) {
            return translations[this.$store.state.locale][cat][key];
        },
        updateQueryParams() {
            let queries = JSON.parse(JSON.stringify(this.$route.query));

            queries.page = this.params.page;
            queries.perPage = this.params.perPage;
            queries.sortBy = this.params.sortBy;
            queries.sortDirection = this.params.sortDirection;

            if (
                this.name === "hotels" ||
                this.name === "restaurants" ||
                this.name === "entertainments"
            )
                queries.village_id = this.params.village_id;

            if (this.name === "transports") {
                queries.car_release_year = this.params.car_release_year;
                queries.seats = this.params.seats;
            }
            console.log(queries);
            this.$router.replace({
                path: this.$route.path,
                query: queries,
                hash: "#table",
            });
        },
        debounceSearch(event) {
            this.params.search = "";
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.params.search = event.target.value;
            }, 600);
        },
    },
    mounted() {
        this.getResults();
        this.getCategories();
        this.getMunicipalities();
        this.getVillages();
        this.getLastUpdateDate();
        if (this.name === "agencies") this.getServices();
    },
};
</script>

<style scoped>
.sm-select {
    width: 80px !important;
}

.flex-direction {
    flex-direction: row;
}

.border-input {
    border: 1px solid #c8c9c9;
}

@media only screen and (max-width: 1023px) {
    .flex-direction {
        flex-direction: column;
    }
}

>>> {
    --vs-controls-color: #7973f4;

    --vs-dropdown-color: #cc99cd;
    --vs-dropdown-option-color: #000;

    --vs-selected-bg: #f2f2f2;

    --vs-dropdown-option--active-bg: #7973f4;
    --vs-dropdown-option--active-color: #fff;
}
</style>
